"use strict";

var _classCallCheck = require("/root/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/website/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/website/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/root/website/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulitasExceptionTypes = exports.SimulitasException = void 0;
var SimulitasExceptionTypes = {
  INTENDED_CREDIT_NOT_IN_RANGE_FOR_HOMEREFIN: 'INTENDED_CREDIT_NOT_IN_RANGE_FOR_HOMEREFIN',
  INTENDED_CREDIT_NOT_IN_RANGE_FOR_AUTOREFIN: 'INTENDED_CREDIT_NOT_IN_RANGE_FOR_AUTOREFIN',
  INPUT_VALIDATION_ERROR: 'INPUT_VALIDATION_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
exports.SimulitasExceptionTypes = SimulitasExceptionTypes;

var SimulitasException = /*#__PURE__*/function (_Error) {
  _inherits(SimulitasException, _Error);

  var _super = _createSuper(SimulitasException);

  function SimulitasException(message, type) {
    var _this;

    _classCallCheck(this, SimulitasException);

    _this = _super.call(this, message);
    _this.type = SimulitasExceptionTypes[type];
    return _this;
  }

  _createClass(SimulitasException, [{
    key: "isOutOfRangeError",
    get: function get() {
      return this.type === SimulitasExceptionTypes.INTENDED_CREDIT_NOT_IN_RANGE_FOR_AUTOREFIN || this.type === SimulitasExceptionTypes.INTENDED_CREDIT_NOT_IN_RANGE_FOR_HOMEREFIN;
    }
  }, {
    key: "isUnexpectedError",
    get: function get() {
      return this.type === SimulitasExceptionTypes.SERVER_ERROR || this.type === SimulitasExceptionTypes.UNKNOWN_ERROR || this.type === SimulitasExceptionTypes.INPUT_VALIDATION_ERROR;
    }
  }]);

  return SimulitasException;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.SimulitasException = SimulitasException;